import SignUpTermsAndPrivacy from 'components/SignUpTermsAndPrivacy';
import SocialSignInButton from 'components/SocialSignInButton';
import { VStack } from 'ui/Layout';
import { usePopupWindowOpener } from 'utils/popup';
import { Path } from 'utils/routes';

import { useCreateAndRedirectSankeyIfJustSignedUp } from './utils';

type Props = {
  defaultAction: 'sign-in' | 'sign-up';
};

const AuthenticationOptions: React.FC<Props> = ({ defaultAction }) => {
  const authWitMicrosoft = usePopupWindowOpener(Path.SignInMicrosoftRedirect);
  const authWithGoogle = usePopupWindowOpener(Path.SignInGoogleRedirect);
  const authWithEmail = usePopupWindowOpener(
    defaultAction === 'sign-up' ? Path.SignUpWithEmail : Path.SignInWithEmail
  );

  // If the user has just signed up through any of the popups, create
  // a copy of the current Sankey (assuming it doesn't already belong
  // to the user) and redirect to the new Sankey page in the background.
  useCreateAndRedirectSankeyIfJustSignedUp();

  return (
    <VStack alignItems="stretch" maxWidth="380px" mx="auto" mt={8} mb={6}>
      <SocialSignInButton
        icon="microsoft"
        label="Continue with Microsoft"
        onClick={authWitMicrosoft}
      />
      <SocialSignInButton
        icon="google"
        label="Continue with Google"
        onClick={authWithGoogle}
      />
      <SocialSignInButton
        icon="envelope-regular"
        label="Continue with email"
        onClick={authWithEmail}
      />
      <SignUpTermsAndPrivacy />
    </VStack>
  );
};

export default AuthenticationOptions;
